import React from 'react';
import { FormValue, useField } from 'informed';

import { useStateAndDistricts } from '../../hooks/useStateAndDistricts';
import { getStateDetailsFromStateId } from '../../utils/ComboBoxUtils';

import { StatesComboBox } from '../StatesComboBox';
import { StatesComboBoxProps } from '../StatesComboBox/StatesComboBox';
import { State } from '../types';

import { FieldContainer } from './styledComponents';

export interface InformedStatesComboboxProps extends StatesComboBoxProps {
  isHidden?: boolean;
  field: string;
  validationSchemaObject: any;
  touched: boolean;
  isDisabled?: boolean;
  reRenderObjects?: Array<any>;
  fieldWrapperStyles?: React.CSSProperties;
  initialStateValue?: string;
  getDisplayValueFromSelectedState?: (T: any) => string;
  validateOnChange?: boolean;
  validateOnBlur?: boolean;
  helperText?: string;
  isMarginBottomZero?: boolean;
  hintClassName?: string;
  enableDataMask?: boolean;
  mobilePlaceholder?: string;
}

export const InformedStatesCombobox = (props: InformedStatesComboboxProps) => {
  const {
    isHidden,
    field,
    validationSchemaObject,
    fieldWrapperStyles,
    touched,
    onSelectionChange,
    isDisabled,
    label,
    error,
    onBlur: onBlurPropFunc,
    reRenderObjects,
    initialStateValue,
    getDisplayValueFromSelectedState,
    validateOnBlur = true,
    validateOnChange = true,
    helperText,
    isMarginBottomZero,
    hintClassName,
    enableDataMask,
    ...comboboxProps
  } = props;

  const { fieldState, render, informed } = useField<
    FormValue<{ state_id: string; state_name: string }>
  >({
    field,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validationSchema: validationSchemaObject.fields[field],
    error: error,
    touched: touched,
    isDisabled,
    label,
    ...reRenderObjects
  });

  const { value } = fieldState;
  const { onChange, onBlur } = informed;

  const onBlurFunction = (e) => {
    onBlur(e.target.value);
    onBlurPropFunc && onBlurPropFunc(e.target.value);
  };

  const { states } = useStateAndDistricts();

  const onSelectionChangeFunc = (value) => {
    const state = getStateDetailsFromStateId(value, states.current);
    onChange(state);
    onSelectionChange && onSelectionChange(state?.state_id);
  };

  const renderStatesCombobox = () => {
    return (
      <StatesComboBox
        label={label}
        selectedKey={(value as State)?.state_id}
        onBlur={onBlurFunction}
        isDisabled={isDisabled}
        onSelectionChange={onSelectionChangeFunc}
        error={error}
        initialStateValue={initialStateValue}
        getDisplayValueFromSelectedState={getDisplayValueFromSelectedState}
        helperText={helperText}
        hintClassName={hintClassName}
        enableDataMask={enableDataMask}
        {...comboboxProps}
      />
    );
  };

  return render(
    <FieldContainer
      isHidden={isHidden}
      css={fieldWrapperStyles}
      isMarginBottomZero={isMarginBottomZero}
    >
      {renderStatesCombobox()}
    </FieldContainer>
  );
};
